import React, { useState } from 'react';
import { useAssignmentContext } from '../../../context';
import {
  faChevronRight,
  faKey,
  faList,
  faHistory,
  faSwatchbook
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DropDown from '../../../../../../src/components/DropDown';
import CustomToast from '../../../../../../src/components/Toast';
import Modal from '../../../../../components/Modal';
import {
  useRenameAssignmentMutation,
  useUpdateTeacherNoteMutation,
  useReclassifyCourseMutation,
  useSetMcStyleMutation,
  useGetAnswerHistoryMutation,
  useGetAssignmentPropertiesMutation,
  useGetQuestionPropertiesMutation
} from '../../../../../features/authentication/assignmentApislice';
import {
  useReclassifyFlashcardCourseMutation,
  useRenameFlashcardMutation,
  useUpdateFlashcardTeacherNoteMutation
} from '../../../../../features/authentication/activityApiSlice';
import PropTypes from 'prop-types';
import { useGetAllCourseListMutation } from '../../../../../features/authentication/authApiSlice';
import { useEffect } from 'react';
import ConfirmationModal from '../../../../../components/ConfirmationPopUp';
import { Link } from 'react-router-dom';
import html2pdf from 'html2pdf.js';
import QuestionPropertiesModal from '../../../../questionsSearch/components/castleQuestionsSearch/components/QuestionPropertiesModal';
import PropertiesModal from '../../../components/PropertiesModal';
import ProgressButton from '../../../../../components/ProgressButton';
import Languages from '../../../../../enums/languages';
import ActivityTypes from '../../../../../enums/activityTypes';

const EditAssignmentOptionsModal = ({
  assignmentInfo,
  setQuestions,
  selectedMcStyle,
  setSelectedMcStyle,
  mcChoices,
  currentQuestionId,
  questionCourseId,
  isBlockedQuestion,
  fromFlashcard
}) => {
  const { assignmentId, setAssignmentCourseId } = useAssignmentContext();
  const selectedAssignment = useAssignmentContext();
  const [isModifyOpen, setIsModifyOpen] = useState(true);
  const [assignmentEditName, setAssignmentEditName] = React.useState('');
  const [propertiesOpen, setPropertiesOpen] = useState(false);
  const [displayPrintOpen, setDisplayPrintOpen] = useState(true);
  const [renameAssignment] = useRenameAssignmentMutation();
  const [renameFlashcard] = useRenameFlashcardMutation();
  const [contentNote, setContentNote] = useState('');
  const [noteDescription, setNoteDescription] = useState('');
  const [teacherNoteModel, setTeacherNoteModel] = useState(false);
  const [updateTeacherNote] = useUpdateTeacherNoteMutation();
  const [updateFlashcardTeacherNote] = useUpdateFlashcardTeacherNoteMutation();
  const [reclassifyModel, setReclassifyModel] = useState(false);
  const [getAllCourses] = useGetAllCourseListMutation();
  const [allCourses, setAllCourses] = useState('');
  const [selectedCourseId, setSelectedCourseId] = useState('');
  const [reclassifyCourse] = useReclassifyCourseMutation();
  const [confirmModel, setConfirmModel] = useState(false);
  const [setMcStyle] = useSetMcStyleMutation();
  const [getAnswerHistory] = useGetAnswerHistoryMutation();
  const [allAnswerHistory, setAllAnswerHistory] = useState([]);
  const [answerHistoryModel, setAnswerHistoryModel] = useState(false);
  const [openAssignmentProperties, setOpenAssignmentProperties] = useState(false);
  const [assignmentProperties, setAssignmentProperties] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [getAllAssignmentProperties] = useGetAssignmentPropertiesMutation();
  const [getQuestionProperties] = useGetQuestionPropertiesMutation();
  const [showQuestionPropertiesModal, setShowQuestionPropertiesModal] = useState(false);
  const [propertiesResult, setPropertiesResult] = useState({});
  const [isPdfGenerating, setIsPdfGenerating] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(Languages.English);
  const [reclassifyFlashcardCourse] = useReclassifyFlashcardCourseMutation();
  const activityType = fromFlashcard ? ActivityTypes.FlashCard : ActivityTypes.Assignment;
  const languages = [
    {
      id: Languages.English,
      name: 'English Only'
    },
    {
      id: Languages.Spanish,
      name: 'Spanish if available'
    }
  ];

  React.useEffect(() => {
    setAssignmentEditName(assignmentInfo.assignmentName);
    setSelectedCourseId(assignmentInfo.courseId);
    selectedAssignment.setAssignmentCourseId(assignmentInfo.courseId);
    selectedAssignment.setAssignmentName(assignmentInfo.assignmentName);
    selectedAssignment.setAssignmentId(assignmentInfo.assignmentId);
  }, [assignmentInfo]);

  const getRenameOperation = () => {
    const isFlashcard = fromFlashcard;
    return {
      mutate: isFlashcard ? renameFlashcard : renameAssignment,
      buildOptions: (id, value) => isFlashcard
        ? { id, flashcardName: encodeURIComponent(value) }
        : { assignmentId: id, assignmentName: encodeURIComponent(value) },
      successMsg: isFlashcard ? 'Flashcard name changed successfully' : 'Assignment name changed successfully'
    };
  };

  const changeAssignmentName = async (value) => {
    try {
      const { mutate, buildOptions, successMsg } = getRenameOperation();
      const options = buildOptions(assignmentId, value);
      const response = await mutate(options);

      if (response.error) {
        CustomToast(response.error.data.error, 'error');
      } else {
        const updatedInfo = { ...assignmentInfo, assignmentName: value };
        setQuestions(updatedInfo);
        selectedAssignment.setAssignmentName(value);
        CustomToast(successMsg, 'success');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAssignmentEdit = (event) => {
    setAssignmentEditName(event.target.value);
  };

  const handleOutsideClick = (event) => {
    if (event.target.value.trim().length === 0)
      CustomToast('Assignment name cannot be empty', 'warning');
    else if (assignmentInfo.assignmentName == assignmentEditName) return;
    else changeAssignmentName(event.target.value);
  };

  const teacherNoteDescription = (event) => {
    setContentNote(event.target.value);
    setNoteDescription(event.target.value);
  };

  const getNoteOperation = () => {
    const isFlashcard = fromFlashcard;
    return {
      mutate: isFlashcard ? updateFlashcardTeacherNote : updateTeacherNote,
      buildOptions: (id, note) => isFlashcard
        ? { id, note }
        : { assignmentId: id, assignmentNote: note },
      successMsg: isFlashcard ? 'Flashcard Note saved successfully' : 'Assignment Note saved successfully'
    };
  };

  const saveNote = async () => {
    try {
      const { mutate, buildOptions, successMsg } = getNoteOperation();
      const options = buildOptions(assignmentId, noteDescription);
      const response = await mutate(options);

      if (response.error) {
        CustomToast(response.error?.data?.error ?? 'Unable to save note.', 'error');
        setTeacherNoteModel(false);
        return;
      }

      const updatedInfo = { ...assignmentInfo, assignmentNote: noteDescription };
      setQuestions(updatedInfo);
      CustomToast(successMsg, 'success');
      setTeacherNoteModel(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllCoursesAsync();
  }, []);

  const getAllCoursesAsync = async () => {
    try {
      const allCoursesResponse = await getAllCourses().unwrap();
      allCoursesResponse !== null && allCoursesResponse !== undefined;
      setAllCourses(allCoursesResponse);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectCourse = (event) => {
    const selectedCourseId = parseInt(event.target.value);
    setSelectedCourseId(selectedCourseId);
  };

  const getReclassifyOperation = () => {
    const isFlashcard = fromFlashcard;
    return {
      mutate: isFlashcard ? reclassifyFlashcardCourse : reclassifyCourse,
      buildOptions: (id, courseId) => isFlashcard
        ? { id, courseId }
        : { assignmentId: id, courseId },
      successMsg: isFlashcard ? 'Flashcard reclassified to new course' : 'Assignment reclassified to new course'
    };
  };

  const saveCourse = async () => {
    if (selectedCourseId === selectedAssignment.assignmentCourseId) {
      CustomToast('Cannot be reclassified to the same course.', 'warning');
      setConfirmModel(false);
      setReclassifyModel(false);
      return;
    }

    try {
      const { mutate, buildOptions, successMsg } = getReclassifyOperation();
      const options = buildOptions(assignmentId, selectedCourseId);
      const response = await mutate(options);

      if (response.error) {
        CustomToast(response.error?.data?.error ?? 'Unable to reclassify course.', 'error');
        setConfirmModel(false);
        setReclassifyModel(false);
        return;
      }

      const selectedCourse = allCourses.filter((item) => item.id === selectedCourseId);
      if (selectedCourse.length > 0) {
        const updatedInfo = { ...assignmentInfo, courseName: selectedCourse[0].name, courseId: selectedCourseId };
        setQuestions(updatedInfo);
      }

      setAssignmentCourseId(selectedCourseId);
      CustomToast(successMsg, 'success');
      setConfirmModel(false);
      setReclassifyModel(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleMcStyle = (event) => {
    const selectedMcStyleId = parseInt(event.target.value);
    setSelectedMcStyle(selectedMcStyleId);
    setMcStyleOption(selectedMcStyleId);
  };

  const setMcStyleOption = async (mcstyle) => {
    try {
      let option = {
        assignmentId: assignmentId,
        mcStyle: mcstyle
      };
      const response = await setMcStyle(option);
      if (response.error) {
        CustomToast(response.error.data.error, 'error');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAnswerHistory = async () => {
    const options = { assignmentId };
    const response = await getAnswerHistory(options);

    if (response.error) {
      CustomToast(response.error.data.error, 'error');
      return;
    }

    setAllAnswerHistory(response.data);
    setAnswerHistoryModel(true);
  };

  const handleLanguageChange = (event) => {
    setSelectedLanguage(parseInt(event.target.value));
  };

  const handlePrintPdf = async () => {
    if(isPdfGenerating) return;

    setIsPdfGenerating(true);
    const contentWrapper = document.getElementById('answer-history-pdf');
    const contentClone = contentWrapper.cloneNode(true);
    const buttonGroup = contentClone.querySelector('#answer-history-header');
    buttonGroup.classList.remove('d-none');

    const tables = contentClone.getElementsByTagName('table');

    for (let i = 0; i < tables.length; i++) {
      const table = tables[i];
      table.style.pageBreakInside = 'avoid';
      table.style.breakInside = 'avoid';
      table.style.keepWithWindow = 'always';
    }

    const options = {
      margin: 40,
      filename: 'answer-history.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 3 },
      jsPDF: { unit: 'pt', format: 'a2', orientation: 'portrait' }
    };

    await html2pdf().set(options).from(contentClone).save(`${assignmentInfo.assignmentName}.pdf`);
    setIsPdfGenerating(false);
  };

  const handleAssignmentProperties = () => {
    setOpenAssignmentProperties(true);
    getAllAssignmentPropertiesAsync();
  };

  const getAllAssignmentPropertiesAsync = async () => {
    if (!isLoading) {
      setIsLoading(true);
      try {
        const option = {
          assignmentId: assignmentId
        };
        const allAssignmentsPropertiesResponse = await getAllAssignmentProperties(
          option
        );
        if (allAssignmentsPropertiesResponse.error) {
          CustomToast(allAssignmentsPropertiesResponse.error.data.error, 'error');
        }
        else {
          setAssignmentProperties(allAssignmentsPropertiesResponse.data);
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.log(error);
      }
    }
  };

  const handleQuestionProperties = () => {
    getAllQuestionPropertiesAsync();
    setShowQuestionPropertiesModal(true);
  };

  const getAllQuestionPropertiesAsync = async () => {
    if (!isLoading) {
      setIsLoading(true);
      try {
        const options = {
          questionId: currentQuestionId,
          assignmentId: assignmentId,
          courseId: questionCourseId
        };
        const allQuestionPropertiesResponse = await getQuestionProperties(
          options
        );
        if (allQuestionPropertiesResponse.error) {
          if(allQuestionPropertiesResponse.error?.data?.error)
            CustomToast(allQuestionPropertiesResponse.error.data.error, 'error');
          setShowQuestionPropertiesModal(false);
        }
        else {
          setPropertiesResult(allQuestionPropertiesResponse);
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.log(error);
      }
    }
  };

  return (
    <>
      <div className="mt-3 classroom-content">
        <div className={`classroom-content-box ${isModifyOpen && 'open'}`}>
          <div className="classroom-content-header justify-content-between align-item-center d-flex cursor-pointer" onClick={() => setIsModifyOpen(!isModifyOpen)} >
            <h6 className='align-content-center mb-0 no-select'>{fromFlashcard ? 'Modify Flashcard' : 'Modify Assignment'}</h6>
            <button className="z-index10 grey-clr">
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
          {isModifyOpen && (
            <div>
              <div>
                <div>Rename the {fromFlashcard ? 'flashcard' : 'assignment'}</div>
                <div>
                  <input
                    className="form-control"
                    value={assignmentEditName}
                    onChange={handleAssignmentEdit}
                    onBlur={handleOutsideClick}
                  />
                </div>
              </div>
              {!fromFlashcard && (           
                <div className="mt-2">
                  <DropDown
                    label="Multiple Choice Style"
                    value={mcChoices}
                    selectedValue={selectedMcStyle}
                    description={true}
                    onChangeHandler={(e) => handleMcStyle(e)}
                  />
                </div>
              )}
              <div className="d-flex">
                <button
                  className={'btn btn-castleWhite mr-2 mt-3 py-2 h-auto'}
                  onClick={() => {
                    setTeacherNoteModel(true);
                    setContentNote(assignmentInfo.assignmentNote);
                  }}>
                  {assignmentInfo.assignmentNote === null || assignmentInfo.assignmentNote === ''
                    ? fromFlashcard
                      ? 'Create Flashcard Note'
                      : 'Create Assignment Note'
                    : fromFlashcard
                      ? 'Edit Flashcard Note'
                      : 'Edit Assignment Note'}
                </button>
                <button
                  className={'btn btn-castleWhite mt-3 py-2 h-auto'}
                  onClick={() => setReclassifyModel(true)}>
                  Reclassify to Another Course
                </button>
              </div>
            </div>
          )}
        </div>
      </div>  
      {!fromFlashcard && (    
        <div className="line"></div>
      )}
      {!fromFlashcard && (
        <div className="mt-3 classroom-content">
          <div className={`classroom-content-box ${propertiesOpen && 'open'}`}>
            <div className="classroom-content-header justify-content-between align-item-center d-flex cursor-pointer" onClick={() => setPropertiesOpen(!propertiesOpen)}>
              <h6 className='align-content-center mb-0 no-select'>Properties</h6>
              <button className="z-index10 grey-clr">
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </div>
            {propertiesOpen && <div className="d-flex">
              <button
                className={`btn btn-castleWhite mr-2 mt-3 py-2 h-auto w-50 ${isBlockedQuestion && 'disabled'}`}
                onClick={() =>
                  handleQuestionProperties()
                }>
              Question
              </button>
              <button
                className={'btn btn-castleWhite mt-3 py-2 h-auto w-50'}
                onClick={() => handleAssignmentProperties()}>
              Assignment
              </button>
            </div>}
          </div>
        </div>
      )}
      <div className="line"></div>
      <div className="mt-3 w-100">
        <div className="mt-3 classroom-content">
          <div className={`classroom-content-box ${displayPrintOpen && 'open'}`}>
            <div className="classroom-content-header justify-content-between align-item-center d-flex cursor-pointer" onClick={() => setDisplayPrintOpen(!displayPrintOpen)}>
              <h6 className='align-content-center mb-0 no-select'>Print</h6>
              <button className="z-index10 grey-clr">
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </div>
            {displayPrintOpen && (
              <div>
                {!fromFlashcard && (
                  <div className="mt-3">
                    <DropDown
                      label="Language"
                      value={languages}
                      selectedValue={selectedLanguage}
                      description={true}
                      onChangeHandler={(e) => handleLanguageChange(e)}
                    />
                  </div>
                )}
                <div className="d-flex mt-3">
                  {!fromFlashcard && (
                    <Link
                      className="d-flex align-items-center text-decoration-none text-body cursor-pointer mr-2 w-50"
                      data-end="true"
                      to={`/assignments/${assignmentId}/standardPrinting`}
                      state={{ assignmentId: assignmentId, assignmentName: assignmentEditName, languageId: selectedLanguage }}>
                      <span className="blue-icon align-content-center">
                        <FontAwesomeIcon icon={faSwatchbook} className="px-1" />
                      </span>
                    Assignment
                    </Link>
                  )}
                  <Link
                    className="d-flex align-items-center text-decoration-none text-body cursor-pointer w-50"
                    data-end="true"
                    to={`/assignments/${assignmentId}/vocabularyPrinting/${activityType}`}
                    state={{ assignmentId: assignmentId, assignmentName: assignmentEditName }}>
                    <span className="blue-icon align-content-center">
                      <FontAwesomeIcon icon={faList} className="px-1" />
                    </span>
                    {fromFlashcard ? 'Flashcard' : 'Vocabulary'}
                  </Link>
                </div>
                {!fromFlashcard && (
                  <div className="d-flex mt-3">
                    <Link
                      className="d-flex align-items-center text-decoration-none text-body cursor-pointer mr-2 w-50"
                      data-end="true"
                      to={`/assignments/${assignmentId}/answerKey`}
                      state={{ assignmentId: assignmentId, assignmentName: assignmentEditName }}>
                      <span className="blue-icon align-content-center">
                        <FontAwesomeIcon icon={faKey} className="px-1" />
                      </span>
                    Answer Key
                    </Link>
                    <div className="d-flex align-items-center cursor-pointer w-50" onClick={() => handleAnswerHistory()}>
                      <span className="blue-icon align-content-center">
                        <FontAwesomeIcon icon={faHistory} className="px-1" />
                      </span>
                    Answer History
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <Modal
        contentWidth="600px"
        isOpen={teacherNoteModel}
        titleName={'Teacher Notes'}
        onClose={() => setTeacherNoteModel(false)}>
        <textarea
          type="text"
          className="form-control textarea-lg"
          placeholder=" "
          name="noteDescription"
          id="noteDescription"
          value={contentNote}
          onChange={teacherNoteDescription}
        />
        <div className="d-flex justify-content-end mt-3 gap-3 align-items-center">
          <button
            className="btn btn-castleGray print-btn"
            onClick={() => {
              setContentNote('');
              setNoteDescription('');
            }}>
            Clear
          </button>
          <button
            className="btn btn-castleGray print-btn"
            onClick={() => setTeacherNoteModel(false)}>
            Cancel
          </button>
          <button className="btn btn-castleRed print-btn" onClick={() => saveNote()}>
            Save
          </button>
        </div>
      </Modal>
      <Modal
        contentWidth="600px"
        isOpen={reclassifyModel}
        titleName={fromFlashcard
          ? 'Reclassify Flashcard To a Different Course'
          : 'Reclassify Assignment To a Different Course'
        }
        onClose={() => {
          setReclassifyModel(false);
          setSelectedCourseId(assignmentInfo.courseId);
        }}
        titleToolTip={
          fromFlashcard
            ? 'All flashcards are categorized to a Castle Learning course, regardless of the original source of the vocabularies that you have included. Because students select flashcards based on the associated course, you should select the course most closely associated with the vocabularies.'
            : 'All assignments are categorized to a Castle Learning course, regardless of the original source of the questions that you have included. Because students select assignments based on the associated course, you should select the course most closely associated with the questions.'
        }>
        <DropDown
          key={'all-course-list'}
          label="Select Course"
          value={allCourses}
          onChangeHandler={(e) => handleSelectCourse(e)}
          selectedValue={selectedCourseId}
        />
        <div className="d-flex justify-content-end mt-3 gap-3 align-items-center">
          <button
            className="btn btn-castleGray print-btn"
            onClick={() => {
              setReclassifyModel(false);
              setSelectedCourseId(assignmentInfo.courseId);
            }}>
            Cancel
          </button>
          <button className="btn btn-castleRed print-btn" onClick={() => setConfirmModel(true)}>
            Save
          </button>
        </div>
      </Modal>
      <ConfirmationModal
        isOpen={confirmModel}
        onClose={() => setConfirmModel(false)}
        onSave={() => saveCourse()}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={fromFlashcard
          ? 'Are you sure that you want to reclassify the flashcard to the selected course?'
          : 'Are you sure that you want to reclassify the assignment to the selected course?'
        }
        cancelButton={'No'}
        confirmButton={'Yes'}
        titleName={'Confirm'}
      />
      <Modal
        contentWidth="700px"
        isOpen={answerHistoryModel}
        titleName={`Answer History for : ${assignmentEditName}`}
        onClose={() => setAnswerHistoryModel(false)}>
        <div id='answer-history-pdf'>
          <h3 id='answer-history-header' className='d-none mb-2'>Answer History for : {assignmentEditName}</h3>
          <div>
            The following table shows the number of correct and incorrect responses for each of the
            assessment&apos;s/assignment&apos;s questions by students in all of your classes. This includes
            responses from any assignment (including any retakes) in which the questions have been
            used. Only the results of assigned questions are included - not the results from
            self-generated students sessions.
          </div>
          <table className="table reportTable list-table mt-4">
            <thead>
              <tr>
                <th className="text-center">Question</th>
                <th className="text-center">Correct</th>
                <th className="text-center">Incorrect</th>
              </tr>
            </thead>
            <tbody>
              {allAnswerHistory.map((item, index) => {
                return (
                  <tr key={index}>
                    <td className="text-center">
                      {index + 1}
                    </td>
                    {item.questionType === 3?(
                      <>
                        <td className="text-center" colSpan={2}>{'Constructed Response(CR)'}</td>
                      </>):(
                      <>
                        <td className="text-center">{item.correct}</td>
                        <td className="text-center">{item.incorrect}</td>
                      </>)
                    }
                    
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="d-flex justify-content-end mt-3 gap-3 align-items-center">
          <button
            className="btn btn-castleGray btn-width"
            onClick={() => setAnswerHistoryModel(false)}>
            Close
          </button>
          <ProgressButton
            isLoading={isPdfGenerating}
            onClick={handlePrintPdf}
            loadingLabel="Generating PDF"
            label="Print to PDF"
            className="btn btn-castleRed"
            expectedDuration={1500}
          />
        </div>
      </Modal>
     
      {openAssignmentProperties &&
      <PropertiesModal
        title={assignmentInfo.assignmentName}
        properties={assignmentProperties}
        isLoading={isLoading}
        openProperties={openAssignmentProperties}
        setOpenProperties={setOpenAssignmentProperties}
        assignmentId = {assignmentInfo.assignmentId}
        isPublicAssignment={false}
      /> 
      }
      {showQuestionPropertiesModal &&
        <QuestionPropertiesModal
          setShowQuestionPropertiesModal={setShowQuestionPropertiesModal}
          showQuestionPropertiesModal={showQuestionPropertiesModal}
          propertiesResult={propertiesResult}
          setPropertiesResult={setPropertiesResult}
          isSearchQuestion={false}
          isLoading={isLoading}
        />
      }
    </>
  );
};

EditAssignmentOptionsModal.propTypes = {
  assignmentInfo: PropTypes.object,
  setQuestions: PropTypes.func,
  selectedMcStyle: PropTypes.number,
  setSelectedMcStyle: PropTypes.func,
  mcChoices: PropTypes.array,
  currentQuestionId: PropTypes.number,
  questionCourseId: PropTypes.number,
  isBlockedQuestion: PropTypes.bool,
  fromFlashcard: PropTypes.bool
};

export default EditAssignmentOptionsModal;
